import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'

import { Button, Modal, ModalHeader } from 'reactstrap'
import { authSelector, consentSelector, consentLogSelector, masterDataSelector } from './../../../selectors'
import { consentAction, consentLogAction, modalAction } from './../../../actions/'
import ConsentManagementForm from '../../../components/consent-management'
import CustomModalMessage from '../../../components/modal-message'
import { EmployeeListConsent } from '../../../components/consent-management/employee-table'
import { getListUser } from '../../../selectors/employee/employee-selector'

class EditConsent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      title: '',
      description: '',
      edit: false,
      id: '',
      activeTab: '1',
      is_active: true,
      user_type: '',
      document_code: '',
      test: {},
      showConsent: false,
      submitSent: false,
    }
    this.handleInput = this.handleInput.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.handleDiscard = this.handleDiscard.bind(this)
    this.deactivateCompany = this.deactivateCompany.bind(this)
    this.handleModelChange = this.handleModelChange.bind(this)
    this.openConsentModal = this.openConsentModal.bind(this)
  }
  componentDidMount() {
    if (get(this.props, 'edit.edit')) {
      this.props.getCompany(get(this.props, 'edit.id'), localStorage.getItem('access_token'))
    }
  }
  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'consentGet')) {
      this.setState({
        title: get(nextProps, 'consentGet.title'),
        description: get(nextProps, 'consentGet.description'),
        user_type: get(nextProps, 'consentGet.user_type'),
        is_active: get(nextProps, 'consentGet.status'),
        document_code: get(nextProps, 'consentGet._id'),
      })

      this.props.resetGetCompany()
    }
    if (get(nextProps, 'edit')) {
      if (get(nextProps, 'edit.edit')) {
        this.setState({ id: get(nextProps, 'edit.id') })
        this.props.handleClickEdit(false, '')
        this.props.getCompany(get(nextProps, 'edit.id'), localStorage.getItem('access_token'))
        this.props.resetGetCompany()
      }
      this.setState({
        edit: false,
      })
    }
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleModelChange(e) {
    this.setState({
      description: e,
    })
  }
  handleClickEdit() {
    this.setState({ edit: true })
  }
  openConsentModal() {
    this.props.editConsent(
      get(this.state, 'id'),
      {
        title: this.state.title,
        description: this.state.description,
        user_type: this.state.user_type,
        status: this.state.is_active,
      },
      localStorage.getItem('access_token')).then(data => {
      if (data.error === true) {
        this.setState({ showConsent: false })
      } else {
        this.setState({ showConsent: true })
      }
    }).catch(error => {
    })
  }
  closeConsentModal = () => {
    this.setState({
      showConsent: false,
      // description: ''
    }
    )
  }
  deactivateCompany() {
    this.props.deactivateCompany(get(this.state, 'id'), localStorage.getItem('access_token'))
  }
  handleDelete() {
    this.deactivateCompany()
    this.props.cancelDelete()
    this.props.handleSpan(false)
  }
  handleDiscard() {
    this.props.cancelDiscard()
    this.props.handleSpan(false)
  }
  submitForm() {
    this.props.editConsent(
      get(this.state, 'id'),
      {
        title: this.state.title,
        description: this.state.description,
        user_type: this.state.user_type,
        status: this.state.is_active,
      },
      localStorage.getItem('access_token'))
  }
  render() {
    const button = (
      <div>
        {/* <NewButton outline color="danger" onClick={ () => this.props.showDelete('confirmDelete') }>Delete</NewButton> */}
        <NewButton color="success" onClick={ this.state.edit ? this.submitForm : this.handleClickEdit }>{ this.state.edit ? 'Save' : 'Edit' }</NewButton>
        <NewButton color="success" onClick={ this.openConsentModal }>Save & Send</NewButton>
      </div>
    )
    const buttonDelete = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDelete }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDelete }>Delete</NewButton>
      </div>
    )
    const buttonDiscard = (
      <div>
        <NewButton color="" onClick={ this.props.cancelDiscard }>Cancel</NewButton>
        <NewButton color="danger" onClick={ this.handleDiscard }>Discard</NewButton>
      </div>
    )
    const closeBtn = <button className="close" onClick={ this.closeConsentModal }>&times;</button>
    return (
      <div>
        {
          get(this.props, 'confirmType') === 'confirmDelete' &&
          <CustomModalMessage
            hide={ this.props.cancelDelete }
            show={ get(this.props, 'confirmType') === 'confirmDelete' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDelete }
          />
        }
        {
          get(this.props, 'confirmType') === 'confirmDiscard' &&
          <CustomModalMessage
            hide={ this.props.cancelDiscard }
            show={ get(this.props, 'confirmType') === 'confirmDiscard' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonDiscard }
          />
        }
        <ConsentManagementForm
          edit={ this.state.edit }
          submitForm={ this.submitForm }
          handleClickEdit={ this.handleClickEdit }
          handleSpan={ this.props.handleSpan }
          handleModelChange={ this.handleModelChange }
          title={ this.state.title }
          description={ this.state.description }
          handleInput={ this.handleInput }
          button={ button }
          confrim={ get(this.props, 'confirm') }
          cancelForm={ this.props.cancelForm }
          showDiscard={ this.state.edit ? this.props.showDiscard : () => this.props.handleSpan(false) }
          user_type={ this.state.user_type }
          is_active={ this.state.is_active }
          id={ this.state.document_code }
          consent={ this.props.consent }
          masterData={ this.props.masterData }
          document_code={ this.state.document_code }
          openConsentModal={ this.openConsentModal }
        />
        {
          get(this.state, 'showConsent') === true &&
          <Modal isOpen={ this.state.showConsent } size='lg'>
            <ModalHeader close={ closeBtn }>Add Employee List</ModalHeader>
            <EmployeeListConsent
              data={ this.props.employeeList }
              masterData={ this.props.listMasterData }
              consentData={ this.state.document_code }
              submitSent={ this.state.submitSent }
              closeBtn={ this.closeConsentModal }
              style={ { 'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto' } }
            />
          </Modal>
        }
      </div>
    )
  }
}

EditConsent.propTypes = {
  editCompany: PropTypes.func.isRequired,
  getCompany: PropTypes.func.isRequired,
  resetGetCompany: PropTypes.func.isRequired,
  handleClickEdit: PropTypes.func.isRequiremasterDataSelectord,
  handleSpan: PropTypes.func.isRequired,
  deactivateCompany: PropTypes.func.isRequired,
  cancelDelete: PropTypes.func.isRequired,
  showDelete: PropTypes.func.isRequired,
  cancelDiscard: PropTypes.func.isRequired,
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
  handleModelChange: PropTypes.func.isRequired,
  getConsentLog: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  authData: authSelector.getUserData,
  consentCreate: consentSelector.getCreateConsentData,
  consentEdit: consentSelector.getEditConsentData,
  consentGet: consentSelector.getGetConsentData,
  companyDeactivate: consentSelector.getDeactivateConsentData,
  consentLogGet: consentLogSelector.getConsentLog,
  employeeList: getListUser,
  listMasterData: masterDataSelector.getGetMasterData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  createCompany: consentAction.createConsent,
  resetCreateCompany: consentAction.resetCreateConsent,
  editConsent: consentAction.editConsent,
  resetEditCompany: consentAction.resetEditConsent,
  getCompany: consentAction.getConsentByID,
  resetGetCompany: consentAction.resetGetConsent,
  listCompany: consentAction.getConsentList,
  deactivateCompany: consentAction.deactivateCosent,
  resetDeactivateCompany: consentAction.resetDeactivateConsent,
  getConsentLog: consentLogAction.getConsentLogByDocCode,
  showConfirm: modalAction.showConfirm,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(EditConsent)

const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`



// WEBPACK FOOTER //
// ./src/pages/consent-management/edit/index.js